import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-header-subtitle mb-15">
                    {this.props.t('opportunities.keyword_clusers.subtitle')}
                </div>
            </>
        );
    }
}

export default ExtraButtons;
